import OverlayBase from "../overlay/OverlayBase";
import SvgLoader from "../../../svg/SvgLoader";
import React from "react";
import {useData} from "../../../hooks/useData";
import {GetPlayerTeamResponse, PlayerTeam} from "../interfaces";
import {useLocalStorage} from "../../../hooks/useLocalStorage";

export default function TeamOverlay(props: { teamId: number, hide: () => void }) {

    const [serverId, ] = useLocalStorage("serverId");
    const data = useData<GetPlayerTeamResponse>(`/api/client/players/team?serverId=${serverId}&teamId=${props.teamId}`);

    return (<OverlayBase hide={props.hide}>
        {data.isLoading && (
            <div className="flex flex-col items-center">
                <SvgLoader/>
                <p className="mt-4 text-white text-lg font-semibold tracking-wide">Loading...</p>
            </div>
        )}
        {data.data && <TeamInfo team={data.data.team} />}
    </OverlayBase>)
}

function TeamInfo({team}: { team: PlayerTeam }) {
    return (<>
        <div className="flex flex-row align-top">
            <div className="flex flex-col select-text">
                <h3 className="text-xl font-bold">Team {team.teamId}</h3>
            </div>
        </div>
        <div className="flex flex-col mt-2 [&>*]:first-child:border-t">
            {team.members.map(p => (<div key={p.steamId} className="border-b border-white py-2 first:border-t">
                <div className="flex flex-row items-center space-x-2 ">
                    <span className={"size-3 rounded-full inline-block " + (p.isConnected ? "bg-green-500" : "bg-neutral-600")}></span>
                    <b>{p.displayName}</b>
                </div>
                <p>{p.steamId}</p>
            </div>))}
        </div>
    </>)
}